import { css } from 'emotion';
import { getInterUIDynamicMetricCssObject } from 'fonts/Inter-UI/metrics';
import { space } from '@joykit';

export namespace styles {
  export const suggestedContainer = (color: string) =>
    css({
      display: 'flex',
      alignItems: 'center',
      margin: space.stack.md,
      fontWeight: 500,
      ...getInterUIDynamicMetricCssObject(15)
    });

  export const colorDot = (color: string) =>
    css({
      backgroundColor: color,
      height: 18,
      width: 18,
      borderRadius: '50%',
      marginRight: 10,
      border: '1px solid #e8e8e8',
      display: 'inline-block',
      verticalAlign: 'middle'
    });

  export const weddingColorContainer = (enabled: boolean) =>
    css({
      display: 'flex',
      justifyContent: 'space-between',
      margin: space.stack.lg,
      opacity: enabled ? 1 : 0.5,
      color: enabled ? '#333' : '#888888',
      ...getInterUIDynamicMetricCssObject(15)
    });

  export const themeDefault = css({
    display: 'flex',
    alignItems: 'center'
  });
}
